import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import Draggable from 'react-draggable';
import './index.scss';
import { CLSTAG } from '@/utils/constant';
import { clstagStr } from '@/utils/util';
interface IProps {
  onClose: AnyFunc;
  title?: string;
  className?: string;
  children?: ReactNode;
  clstag?: CLSTAG;
}
class DraggableModal extends React.PureComponent<IProps, any> {
  timer: any = null;
  dragFlag: boolean = false;
  constructor(props: IProps) {
    super(props);
  }
  render() {
    const { title, onClose, clstag } = this.props;
    return ReactDOM.createPortal(
      <Draggable
        bounds={{
          left: -(window.innerWidth / 2 - 300),
          right: window.innerWidth / 2 - 300,
          top: -(window.innerHeight / 2 - 250),
          bottom: window.innerHeight / 2 - 250,
        }}
      >
        <div className={`draggable-modal ${this.props.className || ''}`}>
          {title && (
            <header className='drag-modal-title'>
              <span>{title}</span>
              <i
                className='close-icon'
                onClick={onClose}
                clstag={clstag && clstagStr(clstag)}
              >
                <svg
                  viewBox='64 64 896 896'
                  focusable='false'
                  data-icon='close'
                  width='1em'
                  height='1em'
                  fill='currentColor'
                  aria-hidden='true'
                >
                  <path d='M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z'></path>
                </svg>
              </i>
            </header>
          )}
          {this.props.children}
        </div>
      </Draggable>,
      document.body,
    );
  }
}
export default DraggableModal;
